import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28419bc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "signup-form" }
const _hoisted_3 = {
  key: 0,
  class: "bg-dark-theme shadow"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "xr-icon-xarcade h1",
    style: {"font-size":"60px"}
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-white text-xl" }, "Verify Registration", -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 1,
  class: "btn-primary-full",
  style: {"font-size":"16px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-3 text-gray-text text-md" }, "Already have an account?", -1))
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Click here to login ")
const _hoisted_11 = { class: "inline-block ml-1" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"my-4\" data-v-28419bc8><span class=\"xr-icon-xarcade h1\" style=\"font-size:60px;\" data-v-28419bc8></span></div><h5 class=\"mb-5 text-white text-xl\" data-v-28419bc8>Verification Successful!</h5><span class=\"xr-icon-check my-4 text-blue-primary\" style=\"font-size:4em;\" data-v-28419bc8></span><p class=\"my-4 text-gray-text\" data-v-28419bc8>You can now start distributing games on Xarcade.</p>", 4)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_authFooter = _resolveComponent("authFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.activeSection == 'verifyUser' || _ctx.activeSection == 'loadingVerifyUser')
        ? (_openBlock(), _createElementBlock("form", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_ctx.activeSection == 'verifyUser')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-primary-full",
                    style: {"font-size":"16px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.verifyUser && _ctx.verifyUser(...args)))
                  }, " Verify User"))
                : _createCommentVNode("", true),
              (_ctx.activeSection == 'loadingVerifyUser')
                ? (_openBlock(), _createElementBlock("button", _hoisted_7, " Verifying..."))
                : _createCommentVNode("", true)
            ]),
            _hoisted_8,
            _createVNode(_component_router_link, {
              to: { name: 'viewAuthLogin' },
              class: "text-blue-primary text-md inline-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("i", _hoisted_11, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-long-arrow-right" })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_authFooter)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeSection == 'verifyUserSuccess')
        ? (_openBlock(), _createElementBlock("form", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "btn-primary-full"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_authFooter)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}